import React, { useState } from 'react';
import { FooterWrapper } from './styled';
import { Link } from 'react-router-dom';

const Footer = () => {
	const [isOpen, setIsOpen] = useState(false);
	const toggle = () => {
		setIsOpen((p) => !p);
	};
	return (
		<FooterWrapper>
			<div className="wrapper">
				<div className="top">
					<div className="footer-logo">
						<a href="/">
							<img src="/images/footer-logo.webp" alt="" />
						</a>
					</div>
					<div className="select-wrap" onClick={toggle}>
						<span className="logo-title">KB 금융 네트워크</span>
						<img src="/images/icon-footer-arrow.svg" alt="" />
						{isOpen && (
							<ul className="toggle-menu">
								<Link to="https://www.kbstar.com/" target="_blank">
									<li>KB국민은행</li>
								</Link>
								<Link to="https://www.kbsec.com/go.able" target="_blank">
									<li>KB증권</li>
								</Link>
								<Link to="https://www.kbinsure.co.kr/main.ec" target="_blank">
									<li>KB손해보험</li>
								</Link>
								<Link
									to="https://card.kbcard.com/CMN/DVIEW/HOAMCXPRIZZC0002"
									target="_blank"
								>
									<li>KB국민카드</li>
								</Link>
								<Link to="https://www.kblife.co.kr/" target="_blank">
									<li>KB라이프생명</li>
								</Link>
								<Link to="http://www.kbam.co.kr/main" target="_blank">
									<li>KB자산운용</li>
								</Link>
								<Link to="https://www.kbcapital.co.kr/main.kbc" target="_blank">
									<li>KB캐피탈</li>
								</Link>
								<Link to="https://www.kbret.co.kr/main.do" target="_blank">
									<li>KB부동산신탁</li>
								</Link>
								<Link to="https://www.kbsavings.com/" target="_blank">
									<li>KB저축은행</li>
								</Link>
								<Link to="http://www.kbic.co.kr/main/index" target="_blank">
									<li>KB인베스트먼트</li>
								</Link>
								<Link to="https://www.kds.co.kr/" target="_blank">
									<li>KB데이타시스템</li>
								</Link>
								<Link
									to="https://www.kbfg.com/kbresearch/index.do"
									target="_blank"
								>
									<li>KB경영연구소</li>
								</Link>
								<Link to="https://www.kbfg.com" target="_blank">
									<li>KB금융그룹</li>
								</Link>
							</ul>
						)}
					</div>
				</div>
				<div className="under">
					<ul>
						<a href="https://www.kbds.co.kr" target="_blank">
							<li>KBDS 홈페이지</li>
						</a>
						<a href="https://www.youtube.com/@kbds" target="_blank">
							<li>YouTube</li>
						</a>

						<a href="https://kbds.career.greetinghr.com/" target="_blank">
							<li>Recruit</li>
						</a>
						<a href="https://www.kbds.co.kr/story/111351" target="_blank">
							<li className="social">소셜 미디어 운영 정책</li>
						</a>
					</ul>
					<p className="copy">
						Copyright © KB Data Systems All Rights Reserved.
					</p>
				</div>
			</div>
			{isOpen ? <div className="dim" onClick={toggle}></div> : ''}
		</FooterWrapper>
	);
};

export default Footer;
